<div class="cdm-body">

    <!-- Close -->
    <div class="cdm-top">
        <button class="cdm-close" type="button" (click)="modal.dismiss()" aria-label="Close">&times;</button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="cdm-loading">
        <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
    </div>

    <!-- Error -->
    <div *ngIf="!loading && error" class="alert alert-warning mb-0">
        Could not load module details.
    </div>

    <!-- Content -->
    <ng-container *ngIf="!loading && !error && entry">

        <!-- Full-width thumbnail -->
        <img *ngIf="entry.module.thumbnailUrl" [src]="entry.module.thumbnailUrl" class="cdm-thumbnail" alt="">

        <!-- Title -->
        <h2 class="cdm-title">{{ entry.module.displayTitlePortal || entry.module.displayTitle }}</h2>

        <!-- Short description -->
        <p class="cdm-description" *ngIf="entry.module.shortDescription">{{ entry.module.shortDescription }}</p>

        <!-- Meta row: category + duration -->
        <div class="cdm-meta" *ngIf="entry.module.moduleCategory || entry.module.duration">
            <span class="cdm-chip" *ngIf="entry.module.moduleCategory">{{ entry.module.moduleCategory.name }}</span>
            <span class="cdm-chip cdm-chip--muted" *ngIf="entry.module.duration">
                <i class="bi bi-clock me-1"></i>{{ entry.module.duration }}
            </span>
        </div>

        <!-- Progress -->
        <div class="cdm-progress">
            <div class="cdm-progress__bar">
                <div class="cdm-progress__fill" [style.width.%]="progressPct(entry.progressValue)"></div>
            </div>
            <span class="cdm-progress__pct">{{ progressPct(entry.progressValue) }}%</span>
        </div>

    </ng-container>

</div>
